'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var FunctionService = function FunctionService($http, $q, $rootScope) {
    var FUNCTIONS = [];
    var FUNCTIONSETTINGS = {};
    var FUNCTIONSCONFIG = {};

    /**
     * Get the list of functionality for the application for the current user as per their role
     */
    var getFunctions = function getFunctions(roleId) {
        var deferred = $q.defer();
        if (roleId == undefined || !roleId) {
            window.location.replace(window.location.origin + '/login');
            deferred.resolve(FUNCTIONS);
        } else {
            if (FUNCTIONS.length === 0) {
                $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
                $http.get(WEBSERVICEURL + '/dataagility/api/service.function/' + roleId).then(function successCallback(response) {
                    if (FUNCTIONS.length === 0) {
                        for (var i = 0; i < response.data.length; i++) {
                            if (FUNCTIONS.indexOf(response.data[i]) === -1) {
                                FUNCTIONS.push(response.data[i]);
                                FUNCTIONSETTINGS[response.data[i].name.replace(/ /g, '')] = response.data[i];
                            }
                        }
                        FUNCTIONSCONFIG = { functionSettings: FUNCTIONSETTINGS, functions: FUNCTIONS };
                    }
                    deferred.resolve(FUNCTIONSCONFIG);
                    $rootScope.$emit('functions-fetched-event', FUNCTIONSCONFIG);
                }, function errorCallback(response) {
                    if (response.status === 401) {
                        window.location.replace(window.location.origin + '/login?logout=true');
                    }
                });
            } else {
                deferred.resolve(FUNCTIONSCONFIG);
            }
        }
        return deferred.promise;
    };

    var resetFunctions = function resetFunctions() {
        var deferred = $q.defer();
        FUNCTIONS = [];
        FUNCTIONSETTINGS = {};
        FUNCTIONSCONFIG = {};
        deferred.resolve(FUNCTIONSCONFIG);
        return deferred.promise;
    };

    return {
        getFunctions: getFunctions,
        // See https://www.codelord.net/2015/05/04/angularjs-notifying-about-changes-from-services-to-controllers/
        subscribe: function subscribe(scope, callback) {
            var handler = $rootScope.$on('functions-fetched-event', callback);
            scope.$on('$destroy', handler);
        },
        resetFunctions: resetFunctions,
        FUNCTIONSCONFIG: FUNCTIONSCONFIG
    };
};

exports.default = FunctionService;


// WEBPACK FOOTER //
// ./client/app/common/services/function.service.js